<div class="flex flex-row">
    <datepicker-field-component [field]="field.dateField" [isUpdate]="isUpdate" [useSummaryView]="useSummaryView">
    </datepicker-field-component>
    <timepicker-field-component [field]="field.timeField" [isUpdate]="isUpdate" [useSummaryView]="useSummaryView">
    </timepicker-field-component>
</div>